"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
exports._ObjectVersion = {
    type: "structure",
    required: [],
    members: {
        ETag: {
            shape: {
                type: "string"
            }
        },
        Size: {
            shape: {
                type: "integer"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        VersionId: {
            shape: {
                type: "string"
            }
        },
        IsLatest: {
            shape: {
                type: "boolean"
            }
        },
        LastModified: {
            shape: {
                type: "timestamp"
            }
        },
        Owner: {
            shape: _Owner_1._Owner
        }
    }
};
//# sourceMappingURL=_ObjectVersion.js.map